import './DropdownMenu.css';

import * as React from 'react';

import DropdownMenuOption from './DropdownMenuOption';

export interface IDropdownMenuOption {
  title: string;
  onClick?(): void;
}

export interface IDropdownMenuProps {
  title: JSX.Element | string;
  options: IDropdownMenuOption[];
  onToggle?(): void;
  disabled?: boolean;
  extraWide?: boolean;
}

export interface IDropdownMenuState {
  isOpen: boolean;
  extraWide: boolean;
}

export default class DropdownMenu extends React.Component<IDropdownMenuProps, IDropdownMenuState> {
  drop: HTMLElement;
  constructor(props: any) {
    super(props);

    this.state = {
      isOpen: false,
      extraWide: (props.extraWide) ? props.extraWide : false
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.onClose, true);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onClose, true);
  }

  onClose = (e: any) => {
    const dropMenu = e.target.closest('.dropdownmenu');
    if (dropMenu !== this.drop) {
      this.setState({ isOpen: false });
    }
  }
  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  }

  render() {
    const { title, options, disabled } = this.props;
    const isOpen = disabled ? false : this.state.isOpen;
    const className = `dropdownmenu ${disabled ? 'is-disabled' : ''}`;
    const styleOverride = this.state.extraWide ? { width: '358px' } : {};
    
    return (
      <div onClick={this.onToggle} className={className} ref={drop => this.drop = drop!}>
        <div className="dropdownmenu-btn" onClick={e => e.nativeEvent.stopImmediatePropagation()} style={styleOverride}>
          {title}
          <i className={`fas fa-angle-${isOpen ? 'up' : 'down'}`} />
        </div>
        {isOpen &&
          <div className="dropdownmenu-options-list" style={styleOverride}>
            {options.map((o, i) => <DropdownMenuOption key={o.title + i} {...o} extraWide={this.state.extraWide}/>)}
          </div>
        }
      </ div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/DropdownMenu.tsx